import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers([
  'overlay',
  'dialogContainer',
  'dialog',
  'closeButton',
  'header',
  'footer',
]);

const DrawerTheme = defineMultiStyleConfig({
  baseStyle: {
    closeButton: {
      padding: '4',
      position: 'absolute',
      right: '16',
      top: '16',
    },
    dialog: {
      background: 'neutral.100',
      display: 'flex',
      flexDirection: 'column',
      gap: '8',
      maxWidth: '20rem',
      padding: '24',
      top: '3rem !important',
    },
    dialogContainer: {
      top: '3rem',
      zIndex: 'dialog',
    },
    footer: {
      justifyContent: 'flex-start',
      marginTop: 'auto',
    },
    header: {
      color: 'neutral.60',
      fontSize: '1',
      fontWeight: 'bold',
      lineHeight: '1rem',
      textTransform: 'uppercase',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      top: '3rem',
      zIndex: 'dialogOverlay',
    },
  },
});

export default DrawerTheme;
